<template>
  <v-sheet
    class="h-100 d-flex flex-column"
    v-bind="$attrs"
  >
    <div
      class="d-flex flex-column justify-center text-center text-md-start"
    >
      <v-img
        v-if="imgSrc"
        v-bind="imgProps"
        class="d-inline-block align-self-center"
      />
      <slot name="content">
        <p
          v-if="title || $slots['title']"
          class="mt-2 mb-0 text-ui-kit-text landing-card-title-2"
        >
          <slot name="title">
            <span
              class="text-pre-line"
              v-html="title"
            />
          </slot>
        </p>
        <p
          v-if="subtitle || $slots['subtitle']"
          class="mt-2 mb-0 text-ui-kit-text-secondary"
        >
          <slot name="subtitle">
            <span
              class="text-pre-line"
              v-html="subtitle"
            />
          </slot>
        </p>
        <div
          v-if="buttonText || $slots['button']"
          class="mt-4 d-flex justify-center"
        >
          <slot name="button">
            <BaseMtButton
              class="px-4"
              color="primary"
              :prepend-icon="buttonIcon"
              @click="$emit('submit')"
            >
              {{ buttonText }}
            </BaseMtButton>
          </slot>
        </div>
      </slot>
    </div>
  </v-sheet>
</template>

<script setup lang="ts">
const PLACEHOLDER_IMG_WIDTH = 150
const PLACEHOLDER_IMG_HEIGHT = 150
const PLACEHOLDER_LARGE_IMG_WIDTH = 175
const PLACEHOLDER_LARGE_IMG_HEIGHT = 175

const props = defineProps({
  imgSrc: { type: String, default: '' },
  imgBig: { type: Boolean, default: false },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  buttonText: { type: String, default: '' },
  buttonIcon: { type: String, default: '' },
})

defineEmits(['submit'])

const imgSizes = computed(() => {
  if (props.imgBig) {
    return {
      width: PLACEHOLDER_LARGE_IMG_WIDTH,
      height: PLACEHOLDER_LARGE_IMG_HEIGHT,
    }
  }

  return {
    width: PLACEHOLDER_IMG_WIDTH,
    height: PLACEHOLDER_IMG_HEIGHT,
  }
})

const imgProps = computed(() => ({
  src: props.imgSrc,
  contain: true,
  width: imgSizes.value.width,
  'min-width': imgSizes.value.width,
  'max-width': imgSizes.value.width,
  height: imgSizes.value.height,
  'min-height': imgSizes.value.height,
  'max-height': imgSizes.value.height,
}))
</script>
